import { AsyncPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

import { provideConfig } from '@spartacus/core';
import { GenericLinkModule } from '@spartacus/storefront';

import { DpClickableLinkComponent } from './clickable-link.component';


@NgModule({
  exports: [DpClickableLinkComponent],
  declarations: [DpClickableLinkComponent],
  imports: [GenericLinkModule, AsyncPipe, MatIcon],
  providers: [
    provideConfig({
      cmsComponents: {
        JavascriptLinkComponent: {
          component: DpClickableLinkComponent
        },
        CMSLinkComponent: {
          component: DpClickableLinkComponent
        }
      }
    })
  ]
})
export class DpClickableLinkModule {}
